var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Input } from 'semantic-ui-react';
import { IconPassword } from './PasswordIcon/PasswordIcon';


var TextInput = function (_a) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, value = _a.value, onChange = _a.onChange, onFocus = _a.onFocus, onBlur = _a.onBlur, name = _a.name, icon = _a.icon, className = _a.className, placeholder = _a.placeholder, label = _a.label, error = _a.error, _c = _a.loading, loading = _c === void 0 ? false : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, input = _a.input, baseInputProps = __rest(_a, ["type", "value", "onChange", "onFocus", "onBlur", "name", "icon", "className", "placeholder", "label", "error", "loading", "disabled", "input"]);
    var _e = React.useState(false), passwordVisible = _e[0], setPasswordVisible = _e[1];
    var togglePasswordVisibility = React.useCallback(function () {
        setPasswordVisible(function (value) { return !value; });
    }, []);
    var classNames = ['pluggy', 'floating-label-input'];
    if (error) {
        classNames.push('has-error');
    }
    if (value !== undefined && value !== null && value !== '') {
        classNames.push('filled');
    }
    if (className) {
        classNames.push(className);
    }
    var combinedClassNames = classNames.join(' ');
    var currentInputType;
    if (type !== 'password') {
        // original type not 'password', keep it as is
        currentInputType = type;
    }
    else {
        // is 'password', check if is on visible state
        currentInputType = passwordVisible ? 'text' : 'password';
    }
    var handleOnChange = React.useCallback(function (event) { return onChange === null || onChange === void 0 ? void 0 : onChange({ name: name, value: event.currentTarget.value }); }, [onChange]);
    var inputIcon = icon ||
        (type === 'password' && (React.createElement(IconPassword, { name: passwordVisible ? 'hide' : 'unhide', onClick: togglePasswordVisibility, className: "icon-password" })));
    return (React.createElement(Input, __assign({}, baseInputProps, { type: currentInputType, value: value, onChange: handleOnChange, onFocus: onFocus, onBlur: onBlur, className: combinedClassNames, placeholder: placeholder, loading: loading, disabled: disabled, input: input, labelPosition: 'right', label: React.createElement("label", { className: 'floating-label' }, label), icon: inputIcon, error: Boolean(error) })));
};
export { TextInput };
